// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__QjDWG","form":"styles_form__WJIYP"};